
jQuery( '.single-gallery-main' ).slick( {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.single-gallery-nav'
} );

jQuery( '.single-gallery-nav' ).slick( {
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.single-gallery-main',
    focusOnSelect: true,
    fade: false,
    arrows: false,
    swipeToSlide: true,
    rows: 0,
} );
